import styled from 'styled-components';
import DefaultButtonStyle from './Default';

const White = styled(DefaultButtonStyle)`
	color: #6c6f88;
	background: #fff;
`;

export default White;
